export const ja: Record<string, string> = {
  app_subtitle: '時間と予算に合わせて、ウィッシュリストから次に遊ぶゲームを見つけよう。',
  steam_id_placeholder: 'Steam64 IDを入力 (例: 76561198012345678)',
  fetch_wishlist: 'リストを取得',
  landing_help: 'Steamプロフィールとリストは<strong>公開</strong>である必要があります。<a href="https://steamid.io" target="_blank" rel="noopener">steamid.io</a> でIDを見つけられます。',
  landing_disclaimer: 'これはファンメイドのプロジェクトであり、<a href="https://store.steampowered.com" target="_blank" rel="noopener">Valve</a>、<a href="https://www.gog.com" target="_blank" rel="noopener">GOG</a>、<a href="https://howlongtobeat.com" target="_blank" rel="noopener">HowLongToBeat</a>とは無関係です。データはブラウザにローカル保存されます。<a href="https://github.com/t0mg/howlong">ソースコードはこちら</a>',
  loading_games_enriched: '{count} / {total} 件処理完了 ({percent}%)',
  loading_throttled_title: 'Steamの要求制限中',
  loading_waiting: '待機中 {time}...',
  loading_stop: '停止して結果を表示',
  loading_stopping: '停止して準備中...',
  loading_fetching_appid: 'AppIDを取得中...',
  loading_fetching_prices: '価格を取得中...',
  loading_fetching_details: 'ゲームの詳細を取得中...',
  loading_fetching_details_count: '{count} 個のゲーム詳細を取得中...',
  loading_enriching: 'HowLongToBeatデータを追加中...',
  loading_enriching_gog: 'GOGデータを追加中...',
  error_wishlist_private: 'リストが空か非公開です。',
  error_no_details: 'ゲームの詳細を取得できませんでした。',
  error_unexpected: '予期せぬエラーが発生しました。',
  error_try_again: '再試行',
  dashboard_change_id: '← Steam IDを変える',
  dashboard_lucky: 'I\'m Feeling Lucky',
  dashboard_insights: '分析',
  dashboard_filter_label: 'フィルター:',
  dashboard_filter_all: '全カテゴリー',
  dashboard_sort_label: '並び替え:',
  dashboard_match_info: 'HLTBデータあり: {found} / {total}',
  dashboard_hltb_warning: '⚠️ サーバーエラーにより一部のHLTBデータが取得できません。再読み込みしてください。',
  lucky_title: 'I\'m Feeling Lucky',
  lucky_desc: '何を遊ぶか迷っていますか？運命に任せましょう。',
  lucky_too_long: 'もっと短い',
  lucky_not_in_mood: '違うジャンル',
  lucky_too_expensive: 'もっと安い',
  lucky_ok: '閉じる',
  lucky_empty: '提案できるゲームがありません！',
  stats_games: 'ゲーム数',
  stats_main: 'メインストーリー',
  stats_main_extra: 'メイン+α',
  stats_completionist: '完全クリア',
  stats_value: 'リスト合計額',
  stats_savings: '節約額',
  sort_priority: '優先順位',
  sort_dateAdded: '追加日',
  sort_name: '名前',
  sort_hltbMain: '時間 (メイン)',
  sort_hltbMainExtra: '時間 (メイン+)',
  sort_hltbCompletionist: '時間 (完全)',
  sort_priceFinal: '価格',
  sort_discountPercent: '割引率',
  settings_title: '設定',
  settings_desc: 'アプリの環境やローカルデータを管理します。',
  settings_region_label: 'Steamの地域表示',
  settings_region_desc: '正しい通貨と価格のため地域を選択します。',
  settings_lang_label: '言語',
  settings_lang_desc: '使用する言語を選択します。',
  settings_clear_hltb_label: 'HLTBデータを削除',
  settings_clear_hltb_desc: '保存されたプレイ時間を削除し再取得します。',
  settings_clear_hltb_btn: 'HLTBをクリア',
  settings_cleared: 'クリアしました！',
  settings_clear_steam_label: 'Steamデータを削除',
  settings_clear_steam_desc: '保存されたゲーム情報を削除します。',
  settings_clear_steam_btn: 'Steamをクリア',
  settings_clear_gog_label: 'GOGデータをクリア',
  settings_clear_gog_desc: 'キャッシュされたGOGのメタデータと価格を削除します。',
  settings_clear_gog_btn: 'GOGをクリア',
  settings_clear_hidden_label: '非表示のゲームをクリア',
  settings_hard_reset_label: '完全リセット',
  settings_hard_reset_desc: 'すべてのキャッシュと設定を初期化します。',
  settings_hard_reset_btn: '全リセット',
  settings_hard_reset_confirm: '本当によろしいですか？すべて消去されます。',
  settings_close: '閉じる',
  insights_title: 'ウィッシュリスト分析',
  insights_desc: 'あなたのウィッシュリストをデータ分析します。',
  insights_avg_price_hr: '1時間あたりの価格',
  insights_oldest_entry: '最も古い追加ゲーム',
  insights_top_genre: '人気ジャンル',
  insights_total_story: '合計クリア時間',
  insights_chart_duration: 'プレイ時間の分布 (時間)',
  insights_chart_price: '価格帯の分布 ({currency})',
  insights_chart_genre: '人気ジャンル比率',
  insights_chart_year: 'ウィッシュリスト追加推移',
  insights_chart_store: '最安ストア: Steam vs GOG',
  game_coming_soon: '近日登場',
  game_demo: '体験版',
  game_demo_avail: '体験版あり',
  game_added: '追加日時: {date}',
  game_free: '無料',
  game_unavailable: '購入不可',
  game_cached: '(キャッシュ)',
  game_price_na: '価格なし',
  game_no_hltb: 'データなし',
  game_hltb_pending: '検索中...',
  game_link_steam: 'Steam',
  game_link_hltb: 'HLTB',
  game_link_gog: 'GOG',
  dashboard_filter_hidden: '非表示のゲーム',
  game_link_hide: '非表示にする',
  game_link_unhide: '表示する',
  hide_confirm_title: 'ゲームを非表示にする',
  hide_confirm_desc: 'このゲームを非表示にしますか？リストからは削除されますが、引き続き追跡されます。',
  hide_confirm_btn: '非表示',
  hide_cancel_btn: 'キャンセル',
};
